<div class="p-6">

  <!-- Header -->
  <div class="flex items-center justify-between mb-5">
    <div>
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Cola de Esperas</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
        Nodos WAIT pendientes del motor de workflows
      </p>
    </div>
    <div class="flex flex-col items-end gap-2">
      <div class="flex gap-2">
        <!--
          INC_CRM_020 (4) inc3 — "Procesar vencidas" era la única acción y es todo-o-nada. Este
          botón actúa solo sobre lo marcado en la tabla, así que el usuario puede forzar una
          espera concreta y comprobar el resultado fila a fila.
        -->
        @if (selectedCount > 0) {
          <button (click)="processSelected()" [disabled]="processing || loading"
                  class="inline-flex items-center gap-1.5 px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
            </svg>
            Procesar {{ selectedCount }} seleccionada{{ selectedCount === 1 ? '' : 's' }}
          </button>
        }
        <button (click)="loadQueue()" [disabled]="loading"
                class="inline-flex items-center gap-1.5 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 disabled:opacity-40 transition-colors">
          <svg class="w-4 h-4" [class.animate-spin]="loading" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          Actualizar
        </button>
        <button (click)="processDue()" [disabled]="processing || loading"
                class="inline-flex items-center gap-1.5 px-4 py-2 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 transition-colors">
          @if (processing) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            Procesando...
          } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            {{ includeActive ? 'Procesar (incluye activas)' : 'Procesar vencidas' }}
          }
          @if (!includeActive && overdueCount > 0) {
            <span class="ml-1 bg-white/30 text-white text-xs px-1.5 rounded-full">{{ overdueCount }}</span>
          }
        </button>
      </div>
      <label class="flex items-center gap-1.5 cursor-pointer text-xs text-gray-600 dark:text-gray-400">
        <input type="checkbox" [(ngModel)]="includeActive"
               class="w-3.5 h-3.5 rounded border-gray-300 text-purple-600 focus:ring-purple-500"/>
        Incluir activas (forzar esperas aún no vencidas)
      </label>
    </div>
  </div>

  <!-- El éxito va por ToastService (INC_CRM_020 (2) inc11); el error queda fijo aquí. -->
  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span><button (click)="error = ''">&times;</button>
    </div>
  }

  <!-- Métricas rápidas -->
  @if (!loading && items.length > 0) {
    <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-3 text-center">
        <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ items.length }}</p>
        <p class="text-xs text-gray-500 mt-0.5">Total</p>
      </div>
      <div class="bg-yellow-50 dark:bg-yellow-900/20 rounded-xl border border-yellow-200 p-3 text-center">
        <p class="text-2xl font-bold text-yellow-700">{{ pendingCount }}</p>
        <p class="text-xs text-yellow-600 mt-0.5">Pendientes</p>
      </div>
      <div class="bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-200 p-3 text-center">
        <p class="text-2xl font-bold text-red-700">{{ overdueCount }}</p>
        <p class="text-xs text-red-600 mt-0.5">Vencidas</p>
      </div>
      <div class="bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 p-3 text-center">
        <p class="text-2xl font-bold text-blue-700">{{ activePendingCount }}</p>
        <p class="text-xs text-blue-600 mt-0.5">Activas (no vencen aún)</p>
      </div>
    </div>
  }

  <!-- Filtros -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4 mb-4">
    <div class="flex flex-wrap gap-3">
      <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        @for (s of statusOptions; track s.value) {
          <option [value]="s.value">{{ s.label }}</option>
        }
      </select>
      <select [(ngModel)]="filterQueueType" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        @for (t of queueTypeOptions; track t.value) {
          <option [value]="t.value">{{ t.label }}</option>
        }
      </select>
      <!--
        INC_CRM_020 (6) inc3 — antes eran dos cajas numéricas, "Workflow ID" y "Enrollment ID".
        Pedían datos que el usuario no tiene: nadie sabe de memoria que el workflow es el 24 ni
        que la inscripción es la 10. Ahora se elige el workflow por su nombre y se busca la
        espera por el nombre del registro inscrito.
      -->
      <select [(ngModel)]="filterWorkflowId" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option value="">Todos los workflows</option>
        @for (w of workflowOptions; track w.id) {
          <option [value]="w.id">{{ w.name }}</option>
        }
      </select>
      <input type="text" [(ngModel)]="filterRecordSearch" (ngModelChange)="onFilterChange()"
             placeholder="Buscar por registro (nombre)"
             class="w-56 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
      @if (filterStatus || filterQueueType || filterWorkflowId !== '' || filterRecordSearch) {
        <button (click)="clearFilters()"
                class="px-3 py-2 text-sm text-gray-500 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          Limpiar
        </button>
      }
    </div>
  </div>

  <!-- Tabla -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
    @if (loading) {
      <div class="flex justify-center py-12 text-gray-400">
        <svg class="animate-spin w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        Cargando esperas...
      </div>
    } @else if (items.length === 0) {
      <div class="flex flex-col items-center justify-center py-14 text-gray-400">
        <svg class="w-12 h-12 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <!--
          INC_CRM_020 (2) inc3, problema 1 — el mensaje anterior era el mismo con y sin
          filtros, así que era imposible saber si la cola estaba vacía de verdad o si el
          filtro por defecto (PENDING) estaba escondiendo los registros.
        -->
        @if (hasActiveFilters) {
          <p class="text-base font-medium text-gray-500 dark:text-gray-400">Ningún resultado con estos filtros</p>
          <p class="text-sm text-gray-400 mt-1">Hay esperas registradas, pero ninguna coincide con la búsqueda actual.</p>
          <button (click)="clearFilters()"
                  class="mt-3 px-3 py-1.5 text-sm text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-50 transition-colors">
            Quitar filtros
          </button>
        } @else {
          <p class="text-base font-medium text-gray-500 dark:text-gray-400">Sin esperas en la cola</p>
          <p class="text-sm text-gray-400 mt-1">Aquí aparecerán los workflows detenidos en un paso de espera.</p>
        }
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <!-- INC_CRM_020 (4) inc3 — selección para "Procesar seleccionadas". -->
              <th class="px-4 py-3 w-10">
                <input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()"
                       [disabled]="selectableItems.length === 0"
                       title="Seleccionar todas las esperas pendientes"
                       class="w-4 h-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500 disabled:opacity-40"/>
              </th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">ID</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Workflow</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Enrollment</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Nodo</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Tipo</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Estado</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Objeto</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Available At</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Intentos</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Procesado</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Error</th>
              <th class="text-right px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (item of items; track item.queueItemId) {
              <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors"
                  [ngClass]="isOverdue(item) ? 'bg-red-50/40 dark:bg-red-900/10' : ''">
                <td class="px-4 py-3">
                  <input type="checkbox" [checked]="isSelected(item)" (change)="toggleSelected(item)"
                         [disabled]="item.status !== 'PENDING'"
                         [title]="item.status === 'PENDING' ? 'Seleccionar esta espera' : 'Solo se pueden procesar esperas pendientes'"
                         class="w-4 h-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500 disabled:opacity-40"/>
                </td>
                <td class="px-4 py-3 font-mono text-xs text-gray-500">#{{ item.queueItemId }}</td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">
                  @if (item.workflowId) {
                    <!--
                      La ruta de detalle `/automation/workflows/:id` ya no existe: el detalle es
                      un modal dentro de la lista (INC_CRM_020 (2) inc4). Este enlace apuntaba a
                      ella y dejaba la pantalla en blanco; lleva al constructor, que es lo útil
                      desde una espera atascada.
                    -->
                    <a [routerLink]="['/automation/workflows', item.workflowId, 'builder']"
                       class="text-blue-600 hover:underline">{{ item.workflowName || ('#' + item.workflowId) }}</a>
                  } @else { — }
                </td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">
                  @if (item.enrollmentId) {
                    <a [routerLink]="['/automation/workflows', item.workflowId, 'enrollments']"
                       class="text-blue-600 hover:underline">#{{ item.enrollmentId }}</a>
                  } @else { — }
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400 font-mono">
                  {{ item.waitNodeId ?? '—' }}
                </td>
                <td class="px-4 py-3">
                  <span class="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 px-1.5 py-0.5 rounded">
                    {{ queueTypeText(item.queueType) }}
                  </span>
                </td>
                <td class="px-4 py-3">
                  <div class="flex flex-col gap-1 items-start">
                    <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium"
                          [ngClass]="getStatusClass(item.status)">
                      {{ statusText(item.status) }}
                    </span>
                    @if (item.status === 'PENDING') {
                      @if (isOverdue(item)) {
                        <span class="inline-flex px-1.5 py-0.5 rounded text-[10px] font-bold bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400">Vencida</span>
                      } @else {
                        <span class="inline-flex px-1.5 py-0.5 rounded text-[10px] font-bold bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400">Activa</span>
                      }
                    }
                  </div>
                </td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">
                  @if (item.objectType) {
                    <div class="flex flex-col">
                      <span class="text-gray-800 dark:text-gray-200">
                        {{ item.objectName || item.objectTypeLabel || objectTypeText(item.objectType) }}
                      </span>
                      <span class="text-[11px] text-gray-400">
                        {{ item.objectTypeLabel || objectTypeText(item.objectType) }} · #{{ item.objectId }}
                      </span>
                    </div>
                  } @else { — }
                </td>
                <td class="px-4 py-3 text-xs"
                    [ngClass]="item.status === 'PENDING' ? 'text-purple-600 font-medium' : 'text-gray-500 dark:text-gray-400'">
                  {{ item.availableAt | date:'dd/MM/yyyy HH:mm' }}
                </td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">
                  {{ item.attempts }}/{{ item.maxAttempts }}
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  {{ item.processedAt ? (item.processedAt | date:'dd/MM HH:mm') : '—' }}
                </td>
                <td class="px-4 py-3 max-w-28">
                  @if (item.lastError) {
                    <span class="text-xs text-red-500 truncate block" [title]="item.lastError">
                      {{ item.lastError | slice:0:28 }}…
                    </span>
                  } @else { <span class="text-gray-300">—</span> }
                </td>
                <td class="px-4 py-3">
                  <div class="flex items-center justify-end gap-1">
                    @if (item.status === 'PENDING') {
                      <button (click)="openCancelModal(item)" title="Cancelar"
                              class="p-1 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="px-4 py-3 border-t border-gray-100 dark:border-gray-700 text-xs text-gray-500">
        {{ items.length }} item(s) en cola
      </div>
    }
  </div>
</div>

<!--
  INC_CRM_020 (6) inc3 — aquí había un modal "Ver payload". `GET /api/workflow-waits/queue` no
  devuelve `payload` (la carga del evento vive en la Cola de Eventos, no en la de Esperas), así
  que el botón que lo abría estaba guardado por un campo que nunca llegaba y no se mostró jamás.
-->
<!-- Modal: Cancelar -->
@if (showCancelModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-sm mx-4 p-6">
      <h3 class="text-base font-semibold text-gray-900 dark:text-white mb-3">Cancelar espera #{{ cancelItemId }}</h3>
      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Motivo <span class="text-gray-400 font-normal">(opcional)</span>
        </label>
        <input type="text" [(ngModel)]="cancelReason" placeholder="Ej: Cancelado manualmente por admin"
               class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
      </div>
      <div class="flex gap-2 justify-end">
        <button (click)="closeCancelModal()" class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50">Cancelar</button>
        <button (click)="confirmCancel()" [disabled]="!!cancellingId"
                class="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
          {{ cancellingId ? 'Cancelando...' : 'Confirmar cancelación' }}
        </button>
      </div>
    </div>
  </div>
}
